// import i18next from 'i18next';

import {
    ADD_TRANSLATIONS,
    RESET_TRANSLATIONS
} from "../constans";

const initState = {
  he: { 

  }
};

const translationsReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case ADD_TRANSLATIONS:
            const newState = {
                he: {
                    ...state.he,
                    ...payload
                }
            }
            return newState
            
        case RESET_TRANSLATIONS: 
            return initState
            
        default:
            return state
    }
};

export default translationsReducer;